<template>
    <div class="main-container">
        <div ref="top" class="top"></div>
        <nav>
            <a href="#!"><img src="@/assets/images/back-arrow.svg" alt="Go Back"></a>
        </nav>
        <main>
            <router-view name="TopHeader" />
            <div class="home">
                <div class="forms">
                    <router-view />
                </div>
                <footer>
                    <Footer />
                </footer>
            </div>
        </main>
        <div id="print">
            <Print />
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { defineAsyncComponent } from 'vue'

const Footer = defineAsyncComponent(() =>
    import ('@/components/Footer.vue'))
const Print = defineAsyncComponent(() =>
    import ('@/components/Print.vue'))


export default {
    name: 'Home',
    components: {
        Footer,
        Print
    },
    mounted: function() {
        document.querySelector('nav a').addEventListener('click', function () {
            event.preventDefault();
            history.back();
        });
    }
}
</script>